export const ROUTES = {
	home: '/',
	login: '/login',
	getDeviceURL(id?: string) {
		return id ? `/devices/${id}` : '/devices/:deviceId';
	},
	deployDevice: '/devices/deploy',
	gpsLockDevice: '/device/gps-lock',
	tasks: '/tasks',
	measurementGroups: '/measurement-groups',
	getMeasurementGroupURL(id?: string | number) {
		return id ? `/measurement-groups/${id}` : '/measurement-groups/:measurementGroupId';
	},
	processObjectFileUpload(mgId?: string | number) {
		return mgId ? `/measurement-groups/${mgId}/upload-file` : '/measurement-groups/:measurementGroupId/upload-file';
	},
	getMeasurementGroupCalibrationUrl(id?: string | number) {
		return id ? `/measurement-groups/${id}/calibration` : '/measurement-groups/:measurementGroupId/calibration';
	},
	processObjects: '/process-objects',
	landowner: '/landowner',
	map: '/map',
	fieldReports: '/field-reports'
};

export const TIME_CONSTANTS_IN_MS = {
	FIVE_MIN: 5 * 60 * 1000,
	ONE_SECOND: 1 * 1000
};
